"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const ButtonBase_1 = __importDefault(require("./ButtonBase"));
const IconButton = ({ size = 15, onPress, image, linkURL = '', children, backgroundColor = 'default', style, }) => {
    return (react_1.default.createElement(ButtonBase_1.default, { to: linkURL, onPress: onPress, style: react_native_1.StyleSheet.flatten([colors[backgroundColor], styles.button, style]) },
        image && react_1.default.createElement(react_native_1.Image, { source: image, style: { height: size, width: size } }),
        children));
};
exports.default = IconButton;
const styles = react_native_1.StyleSheet.create({
    button: {
        borderRadius: styles_1.getRadius(),
        borderColor: styles_1.Colors.secondary,
        borderWidth: styles_1.getSpacing('border'),
        justifyContent: 'center',
        alignItems: 'center',
        width: styles_1.getSpacing('row'),
        height: styles_1.getSpacing('row'),
    },
});
const colors = react_native_1.StyleSheet.create({
    default: {
        backgroundColor: styles_1.Colors.lightgrey,
    },
    transparent: {
        backgroundColor: styles_1.Colors.white,
    },
});
